import { type SVGProps } from 'react';

export function ImageIcon(props: SVGProps<SVGSVGElement>) {
  const { fill = 'currentcolor', width = 16, height = 16, className = '' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <rect width={width} height={height} fill="white" fillOpacity="0.01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33337 1.33334H16.6667C17.7712 1.33334 18.6667 2.22877 18.6667 3.33334V16.6667C18.6667 17.7712 17.7712 18.6667 16.6667 18.6667H3.33337C2.2288 18.6667 1.33337 17.7712 1.33337 16.6667V3.33334C1.33337 2.22877 2.2288 1.33334 3.33337 1.33334ZM3.33337 2.66668C2.96519 2.66668 2.66671 2.96516 2.66671 3.33334V11.1515L4.90911 8.90908C5.02416 8.79402 5.181 8.73064 5.34369 8.73344C5.50637 8.73622 5.66095 8.80497 5.77197 8.92392L10.4981 13.9868L14.2424 10.2424C14.4767 10.0081 14.8567 10.0081 15.091 10.2424L17.3334 12.4848V3.33334C17.3334 2.96516 17.0348 2.66668 16.6667 2.66668H3.33337ZM2.66671 16.6667V12.8485L5.31853 10.1967L10.0415 15.2561L11.9215 17.3333H3.33337C2.96519 17.3333 2.66671 17.0348 2.66671 16.6667ZM16.6667 17.3333H13.54L11.3112 14.8707L14.6667 11.5152L17.3334 14.1819V16.6667C17.3334 17.0348 17.0348 17.3333 16.6667 17.3333ZM8.86567 7.33334C8.86567 6.70685 9.37355 6.19897 10 6.19897C10.6265 6.19897 11.1344 6.70685 11.1344 7.33334C11.1344 7.95984 10.6265 8.46772 10 8.46772C9.37355 8.46772 8.86567 7.95984 8.86567 7.33334ZM10 4.99897C8.7108 4.99897 7.66567 6.0441 7.66567 7.33334C7.66567 8.62258 8.7108 9.66772 10 9.66772C11.2893 9.66772 12.3344 8.62258 12.3344 7.33334C12.3344 6.0441 11.2893 4.99897 10 4.99897Z"
        fill={fill}
      />
    </svg>
  );
}
